// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AmsPublicApiAccountsGetOwnAccountDetailData, AmsPublicApiAccountsGetOwnAccountDetailErrors, AmsPublicApiAccountsGetOwnAccountDetailResponses, AmsPublicApiAccountsRenameOwnAccountData, AmsPublicApiAccountsRenameOwnAccountErrors, AmsPublicApiAccountsRenameOwnAccountResponses, AmsPublicApiConfigGetAuthConfigData, AmsPublicApiConfigGetAuthConfigResponses, AmsPublicApiRolesCreateRoleData, AmsPublicApiRolesCreateRoleErrors, AmsPublicApiRolesCreateRoleResponses, AmsPublicApiRolesDeleteRoleData, AmsPublicApiRolesDeleteRoleErrors, AmsPublicApiRolesDeleteRoleResponses, AmsPublicApiRolesDuplicateRoleData, AmsPublicApiRolesDuplicateRoleErrors, AmsPublicApiRolesDuplicateRoleResponses, AmsPublicApiRolesGetPermissionTreeData, AmsPublicApiRolesGetPermissionTreeErrors, AmsPublicApiRolesGetPermissionTreeResponses, AmsPublicApiRolesListRolesData, AmsPublicApiRolesListRolesErrors, AmsPublicApiRolesListRolesResponses, AmsPublicApiRolesUpdateRoleData, AmsPublicApiRolesUpdateRoleErrors, AmsPublicApiRolesUpdateRoleResponses, AmsPublicApiTokensExchangeTokenData, AmsPublicApiTokensExchangeTokenErrors, AmsPublicApiTokensExchangeTokenResponses, AmsPublicApiTokensGetOwnSessionPermissionsData, AmsPublicApiTokensGetOwnSessionPermissionsErrors, AmsPublicApiTokensGetOwnSessionPermissionsResponses, AmsPublicApiTokensSwitchWorkspaceData, AmsPublicApiTokensSwitchWorkspaceErrors, AmsPublicApiTokensSwitchWorkspaceResponses, AmsPublicApiUsersAssignUserRolesData, AmsPublicApiUsersAssignUserRolesErrors, AmsPublicApiUsersAssignUserRolesResponses, AmsPublicApiUsersCreateUserData, AmsPublicApiUsersCreateUserErrors, AmsPublicApiUsersCreateUserResponses, AmsPublicApiUsersDeleteUserData, AmsPublicApiUsersDeleteUserErrors, AmsPublicApiUsersDeleteUserResponses, AmsPublicApiUsersEditUserData, AmsPublicApiUsersEditUserErrors, AmsPublicApiUsersEditUserResponses, AmsPublicApiUsersGetUserData, AmsPublicApiUsersGetUserErrors, AmsPublicApiUsersGetUserResponses, AmsPublicApiUsersListUsersData, AmsPublicApiUsersListUsersErrors, AmsPublicApiUsersListUsersResponses, AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaData, AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaErrors, AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaResponses, AmsPublicApiWorkspacesAssignUserWorkspacesData, AmsPublicApiWorkspacesAssignUserWorkspacesErrors, AmsPublicApiWorkspacesAssignUserWorkspacesResponses, AmsPublicApiWorkspacesCreateWorkspaceData, AmsPublicApiWorkspacesCreateWorkspaceErrors, AmsPublicApiWorkspacesCreateWorkspaceResponses, AmsPublicApiWorkspacesListSwitchableWorkspacesData, AmsPublicApiWorkspacesListSwitchableWorkspacesErrors, AmsPublicApiWorkspacesListSwitchableWorkspacesResponses, AmsPublicApiWorkspacesListWorkspacesData, AmsPublicApiWorkspacesListWorkspacesErrors, AmsPublicApiWorkspacesListWorkspacesResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get Own Account Detail
 */
export const amsPublicApiAccountsGetOwnAccountDetail = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiAccountsGetOwnAccountDetailData, ThrowOnError>): RequestResult<AmsPublicApiAccountsGetOwnAccountDetailResponses, AmsPublicApiAccountsGetOwnAccountDetailErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiAccountsGetOwnAccountDetailResponses, AmsPublicApiAccountsGetOwnAccountDetailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/account',
    ...options
});

/**
 * Rename Own Account
 */
export const amsPublicApiAccountsRenameOwnAccount = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiAccountsRenameOwnAccountData, ThrowOnError>): RequestResult<AmsPublicApiAccountsRenameOwnAccountResponses, AmsPublicApiAccountsRenameOwnAccountErrors, ThrowOnError> => (options.client ?? client).patch<AmsPublicApiAccountsRenameOwnAccountResponses, AmsPublicApiAccountsRenameOwnAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/account/name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Auth Config
 */
export const amsPublicApiConfigGetAuthConfig = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiConfigGetAuthConfigData, ThrowOnError>): RequestResult<AmsPublicApiConfigGetAuthConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiConfigGetAuthConfigResponses, unknown, ThrowOnError>({ url: '/auth/config', ...options });

/**
 * Get Own Session Permissions
 *
 * Return the permission codes carried by the caller's own token.
 *
 * Not gated by ``grant_required``: the answer is the caller's own permission set, so any grant
 * that could gate it would have to be one the caller might not hold — which would make the
 * endpoint useless to exactly the callers who need it. It discloses nothing the caller did not
 * already present, since the codes come from their own bearer token.
 *
 * No database access and no routing resolution, hence no 404/409: the authenticator already
 * decoded the bitmap into ``CustomerPrincipal.permission_codes`` for this request, and this reads
 * it back. Callers needing the *grantable* tree for an account want ``GET /permissions`` instead;
 * that one is about what may be assigned, this one is about what the caller holds.
 *
 * Sorted so the response is stable across requests, which keeps client-side caching honest.
 */
export const amsPublicApiTokensGetOwnSessionPermissions = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiTokensGetOwnSessionPermissionsData, ThrowOnError>): RequestResult<AmsPublicApiTokensGetOwnSessionPermissionsResponses, AmsPublicApiTokensGetOwnSessionPermissionsErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiTokensGetOwnSessionPermissionsResponses, AmsPublicApiTokensGetOwnSessionPermissionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/permissions',
    ...options
});

/**
 * Switch Workspace
 *
 * Re-mint the caller's token against another workspace they hold a grant on.
 *
 * Authenticated by the caller's current AMS token rather than a Cognito id_token: identity is
 * already settled, so a switch costs one round trip and no trip to the identity provider.
 *
 * Every reason the target is unusable collapses to 404 — see WorkspaceNotSwitchableError. That is
 * this surface's first explicit disclosure decision, since it is the first public route to take a
 * caller-supplied resource identifier at all.
 */
export const amsPublicApiTokensSwitchWorkspace = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiTokensSwitchWorkspaceData, ThrowOnError>): RequestResult<AmsPublicApiTokensSwitchWorkspaceResponses, AmsPublicApiTokensSwitchWorkspaceErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiTokensSwitchWorkspaceResponses, AmsPublicApiTokensSwitchWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/switch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exchange Token
 */
export const amsPublicApiTokensExchangeToken = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiTokensExchangeTokenData, ThrowOnError>): RequestResult<AmsPublicApiTokensExchangeTokenResponses, AmsPublicApiTokensExchangeTokenErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiTokensExchangeTokenResponses, AmsPublicApiTokensExchangeTokenErrors, ThrowOnError>({
    url: '/auth/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Permission Tree
 *
 * Return the grantable permission tree for the caller's own account.
 *
 * Gated by *any* role-management grant — the tree drives every role surface: the create and edit
 * forms render it as an editor, and the read-only standard-role view renders it disabled. Gating on
 * role.create alone would lock role.view/role.edit/role.delete holders (e.g. an Account Admin with
 * only role.view) out of the read-only view. Gating the read still prevents a principal with no
 * role-management capability from enumerating the account's entitlement structure; the tree is
 * already scoped to the account's feature packages.
 */
export const amsPublicApiRolesGetPermissionTree = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiRolesGetPermissionTreeData, ThrowOnError>): RequestResult<AmsPublicApiRolesGetPermissionTreeResponses, AmsPublicApiRolesGetPermissionTreeErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiRolesGetPermissionTreeResponses, AmsPublicApiRolesGetPermissionTreeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/permissions',
    ...options
});

/**
 * List Roles
 *
 * List the roles in the caller's own account (for the role list and duplicate source-picker).
 *
 * Gated by *any* role-management grant — the list is the entry point to create/edit/delete, so a
 * holder of role.create/edit/delete (but not role.view) must still be able to load it.
 */
export const amsPublicApiRolesListRoles = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiRolesListRolesData, ThrowOnError>): RequestResult<AmsPublicApiRolesListRolesResponses, AmsPublicApiRolesListRolesErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiRolesListRolesResponses, AmsPublicApiRolesListRolesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles',
    ...options
});

/**
 * Create Role
 *
 * Create a custom role in the caller's own account.
 */
export const amsPublicApiRolesCreateRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesCreateRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesCreateRoleResponses, AmsPublicApiRolesCreateRoleErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiRolesCreateRoleResponses, AmsPublicApiRolesCreateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate Role
 *
 * Create a custom role in the caller's own account, pre-populated from an existing role.
 */
export const amsPublicApiRolesDuplicateRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesDuplicateRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesDuplicateRoleResponses, AmsPublicApiRolesDuplicateRoleErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiRolesDuplicateRoleResponses, AmsPublicApiRolesDuplicateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Role
 *
 * Delete a custom role in the caller's own account.
 *
 * Same 404-for-both disclosure contract as update_role. Standard and owner roles are immutable (409);
 * a role still assigned to users returns 409 (role_in_use) so the admin reassigns them first.
 */
export const amsPublicApiRolesDeleteRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesDeleteRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesDeleteRoleResponses, AmsPublicApiRolesDeleteRoleErrors, ThrowOnError> => (options.client ?? client).delete<AmsPublicApiRolesDeleteRoleResponses, AmsPublicApiRolesDeleteRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles/{role_code}',
    ...options
});

/**
 * Update Role
 *
 * Edit a custom role's name, description, and permission set in the caller's own account.
 *
 * `role_code` identifies a resource in the path; the role is looked up only within the caller's bound
 * account, so a code that belongs to another account (or does not exist) returns 404 either way —
 * role existence is not enumerable across accounts (CLAUDE.md "Public API Surface Disclosure").
 * Standard and owner roles are immutable and return 409.
 */
export const amsPublicApiRolesUpdateRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesUpdateRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesUpdateRoleResponses, AmsPublicApiRolesUpdateRoleErrors, ThrowOnError> => (options.client ?? client).patch<AmsPublicApiRolesUpdateRoleResponses, AmsPublicApiRolesUpdateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles/{role_code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Users
 */
export const amsPublicApiUsersListUsers = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiUsersListUsersData, ThrowOnError>): RequestResult<AmsPublicApiUsersListUsersResponses, AmsPublicApiUsersListUsersErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiUsersListUsersResponses, AmsPublicApiUsersListUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options
});

/**
 * Create User
 */
export const amsPublicApiUsersCreateUser = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersCreateUserData, ThrowOnError>): RequestResult<AmsPublicApiUsersCreateUserResponses, AmsPublicApiUsersCreateUserErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiUsersCreateUserResponses, AmsPublicApiUsersCreateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User
 *
 * Hard-deletes a user (and their grants) in the caller's own account.
 *
 * ``email`` identifies a user only within the caller's bound account, so an email in another
 * account (or none) returns 404 either way — non-enumerable across accounts (CLAUDE.md "Public
 * API Surface Disclosure"). Deleting the Account Owner is blocked (409) — ownership must
 * transfer first (Scenario 18).
 */
export const amsPublicApiUsersDeleteUser = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersDeleteUserData, ThrowOnError>): RequestResult<AmsPublicApiUsersDeleteUserResponses, AmsPublicApiUsersDeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<AmsPublicApiUsersDeleteUserResponses, AmsPublicApiUsersDeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{email}',
    ...options
});

/**
 * Get User
 */
export const amsPublicApiUsersGetUser = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersGetUserData, ThrowOnError>): RequestResult<AmsPublicApiUsersGetUserResponses, AmsPublicApiUsersGetUserErrors, ThrowOnError> => (options.client ?? client).get<AmsPublicApiUsersGetUserResponses, AmsPublicApiUsersGetUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{email}',
    ...options
});

/**
 * Edit User
 */
export const amsPublicApiUsersEditUser = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersEditUserData, ThrowOnError>): RequestResult<AmsPublicApiUsersEditUserResponses, AmsPublicApiUsersEditUserErrors, ThrowOnError> => (options.client ?? client).put<AmsPublicApiUsersEditUserResponses, AmsPublicApiUsersEditUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{email}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign User Roles
 *
 * Set a user's assigned roles (wholesale) in the caller's own account.
 *
 * Roles are account-level; the user's effective permissions become the union of the assigned roles,
 * reflected on the next token mint. ``email`` identifies a user only within the caller's bound account,
 * so an email in another account (or none) returns 404 either way — non-enumerable across accounts
 * (CLAUDE.md "Public API Surface Disclosure"). The owner role cannot be assigned here (409) — ownership
 * is changed via the transfer flow (Scenario 18).
 */
export const amsPublicApiUsersAssignUserRoles = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersAssignUserRolesData, ThrowOnError>): RequestResult<AmsPublicApiUsersAssignUserRolesResponses, AmsPublicApiUsersAssignUserRolesErrors, ThrowOnError> => (options.client ?? client).put<AmsPublicApiUsersAssignUserRolesResponses, AmsPublicApiUsersAssignUserRolesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{email}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign User Workspaces
 *
 * Set a user's workspace grants (wholesale) in the caller's own account.
 *
 * A workspace grant records that a user may access a workspace within the account; the granted set
 * takes effect on the next token mint (enforcement itself is Scenario 12). ``email`` identifies a
 * user only within the caller's bound account, so an email in another account (or none) returns 404
 * either way — non-enumerable across accounts (CLAUDE.md "Public API Surface Disclosure"). An empty
 * ``workspace_codes`` is valid and removes all of the user's workspace access.
 */
export const amsPublicApiWorkspacesAssignUserWorkspaces = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiWorkspacesAssignUserWorkspacesData, ThrowOnError>): RequestResult<AmsPublicApiWorkspacesAssignUserWorkspacesResponses, AmsPublicApiWorkspacesAssignUserWorkspacesErrors, ThrowOnError> => (options.client ?? client).put<AmsPublicApiWorkspacesAssignUserWorkspacesResponses, AmsPublicApiWorkspacesAssignUserWorkspacesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{email}/workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Workspaces
 *
 * List the workspaces in the caller's own account.
 *
 * Scoped to the caller's bound account; a caller can only ever enumerate its own account's
 * workspaces. Drives the workspace picker on the user detail page.
 */
export const amsPublicApiWorkspacesListWorkspaces = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiWorkspacesListWorkspacesData, ThrowOnError>): RequestResult<AmsPublicApiWorkspacesListWorkspacesResponses, AmsPublicApiWorkspacesListWorkspacesErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiWorkspacesListWorkspacesResponses, AmsPublicApiWorkspacesListWorkspacesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces',
    ...options
});

/**
 * Create Workspace
 *
 * Request an additional workspace in the caller's own account.
 *
 * Returns **202**, not 201: the workspace is reserved synchronously but only becomes usable once
 * MarketPrice has provisioned the backing company and the pipeline materializes it. The response
 * carries the reserved row in ``PROVISIONING`` status so the caller can poll ``GET /workspaces`` for
 * it to turn ``ACTIVE``.
 *
 * The reservation is what makes the quota and the name rule enforceable *before* anything external is
 * called — see ``WorkspaceCreator``. A caller at ``max_workspaces`` gets 409, as does a duplicate name;
 * in-flight reservations count toward both.
 *
 * Gated on ``AMS_WORKSPACE_CREATE_ENABLED`` (default off) until the ``add_workspace`` pipeline
 * consumer ships: without it a reservation would never materialize, permanently holding a name and a
 * quota slot. Returns 503 while disabled.
 */
export const amsPublicApiWorkspacesCreateWorkspace = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiWorkspacesCreateWorkspaceData, ThrowOnError>): RequestResult<AmsPublicApiWorkspacesCreateWorkspaceResponses, AmsPublicApiWorkspacesCreateWorkspaceErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiWorkspacesCreateWorkspaceResponses, AmsPublicApiWorkspacesCreateWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Switchable Workspaces
 *
 * The workspaces the caller may switch into — their own grants, ACTIVE only.
 *
 * Deliberately not a mode of ``GET /workspaces`` above: that one enumerates the whole account and is
 * gated on ``workspace.view``, a different audience. Making one route's grant gate depend on a query
 * parameter would hide the distinction rather than express it.
 */
export const amsPublicApiWorkspacesListSwitchableWorkspaces = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiWorkspacesListSwitchableWorkspacesData, ThrowOnError>): RequestResult<AmsPublicApiWorkspacesListSwitchableWorkspacesResponses, AmsPublicApiWorkspacesListSwitchableWorkspacesErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiWorkspacesListSwitchableWorkspacesResponses, AmsPublicApiWorkspacesListSwitchableWorkspacesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/switchable',
    ...options
});

/**
 * Apply Workspace Users Delta
 *
 * Add and remove users' access to a workspace in the caller's own account.
 *
 * The workspace-centric counterpart to ``PUT /users/{email}/workspaces``. That route is wholesale
 * because a user's workspace set is small and fully loadable; this one is a **delta** because a
 * workspace's user set is unbounded, so a caller cannot send a complete set without risking the
 * revocation of members it never loaded. ``code`` identifies a workspace only within the caller's bound
 * account, so a code in another account (or none) returns 404 either way — non-enumerable across
 * accounts (CLAUDE.md "Public API Surface Disclosure"). An unknown user email, or an email in both
 * ``grant`` and ``revoke``, is a 422. Grants and revokes are idempotent: re-granting a current member or
 * revoking a non-member changes nothing and emits no event. Each genuinely changed user emits the same
 * ``user.workspaces_assigned`` audit event the user-centric flow does.
 */
export const amsPublicApiWorkspacesApplyWorkspaceUsersDelta = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaData, ThrowOnError>): RequestResult<AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaResponses, AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaErrors, ThrowOnError> => (options.client ?? client).patch<AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaResponses, AmsPublicApiWorkspacesApplyWorkspaceUsersDeltaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{code}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
